import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { CommonService } from '../services/common.service';
import { APIService } from './../api.service';
import { DataService } from "../services/data.service";
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-gstr3-b',
    templateUrl: './gstr3-b.component.html',
    styleUrls: ['./gstr3-b.component.scss']
})
export class GSTR3BComponent implements OnInit {

    constructor(public CmnService: CommonService, private apiService: APIService, 
            private ref: ChangeDetectorRef, private router: Router,) { }

    monthList: Array<any> = [];
    accountStartDT: any = null;
    selectedMonthID: any = 0;
    selectedGST: string = "";
    ownGST: string = "";
    supDetailObj: any = {
        type: '',
        samt: 0 + '',
        csamt: 0 + '',
        txval: 0 + '',
        camt: 0 + '',
        iamt: 0 + '',
        count: 0,
        SupType: '',
        total_tax: 0 + ''
    }
    itcObj: any = {
        type: '',
        ty: '',
        samt: 0 + '',
        csamt: 0 + '',
        camt: 0 + '',
        iamt: 0 + ''
    }
    inwardSuppliesObj: any = {
        ty: '',
        name: '',
        intra: 0 + '',
        inter: 0 + ''
    }
    interSupObj = {
        type: '',
        state: '',
        pos: '',
        txval: 0 + '',
        iamt: 0 + '',
        count: 0,
        IType: ''
    }
    supDetailArr: any = [];
    interSupArr: any = [];
    itcArr: any = [];
    inEligibleArr: any = [];
    itcRevArr: any = [];
    inwardSuppliesArr: any = [];
    itcNetArr: any = [];
    intr_detailsArr: any = []
    GSTR3B: any = {
        'gstin':'',
        'ret_period':'',
        'sup_details': {},
        'inter_sup': {},
        'itc_elg': {},
        'inward_sup': {},
        'intr_ltfee': {},
        // 'hash': '',
        // 'version': ''
    };
   
    curDate: any = new Date();
    jarvisData: any = [];
    agencyData: any = [];
    DataList: any = [];
    gstLocations: Array<any> = [];
    isEGST: boolean = false;

    // view = {
    //     month: this.curDate.getMonth() + 1,
    //     year: this.curDate.getFullYear()
    // }
    months: any = [];
    years: any = [];
    month: any;
    year: any;
    monthval: any = this.curDate.getMonth() + 1;
    right: any;
    period = 3; //other 
    ngOnInit(): void {

        var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }

        // Check Rights
        this.right = this.apiService.getCookie("J");
        if(this.right){
            this.right = JSON.parse(this.right);
            let ownUserID: number = this.jarvisData[0].UserID;
            this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
            if(!this.right.Accts){
                this.router.navigate(['/accounts'],);
                return;
            }
        }

        this.getDates()

        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
            this.ownGST = this.agencyData[0].GSTIN;
            this.isEGST = this.agencyData[0].EGST;
            let gstLocation = this.agencyData[0].Locations;
            if(gstLocation.length > 0){
                this.gstLocations = JSON.parse(gstLocation);
                this.gstLocations = this.gstLocations.filter((o: any) => o.IsD == false);
                let key = 'GST';
                let finalPrd = this.gstLocations;
                this.gstLocations = [...new Map(finalPrd.map(finalPrd =>[finalPrd[key], finalPrd])).values()];
                if(this.gstLocations.length > 0){
                    this.selectedGST = this.gstLocations[0].GST;
                }
            }
        }

        let tmpERP_Agn: any = this.apiService.getCookie("ERP_Agn");
        if (tmpERP_Agn) {
            tmpERP_Agn = JSON.parse(tmpERP_Agn);
        }
    
        if (tmpERP_Agn.length > 0) {
          this.accountStartDT = new Date(tmpERP_Agn[0].AccountStartDT);
        }

        // this.monthList = this.CmnService.getMonthYear(new Date(this.accountStartDT), new Date(new Date().setMonth(new Date().getMonth() - 1)))
        this.monthList = this.CmnService.getMonthYear(new Date(this.accountStartDT), new Date())
        
        if(this.monthList.length > 0){
            this.selectedMonthID = this.monthList[this.monthList.length - 2].id + "";
        }

        this.changeFilter(this.period);
        //this.getListData();
    }
    

    getDates() {
        var date = new Date();
        var currentYear: any = date.getFullYear();

        //set values for year dropdown
        for (let i = 0; i <= 1; i++) {
            this.years.push(currentYear - i);
        }

        //set values for month dropdown
        this.months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        this.month = this.months[this.curDate.getMonth()];
        this.year = this.curDate.getFullYear();

    }

    stateList: any = [
        {
            stateName: '',
            gstCode: 0
        }, {
            stateName: 'Jammu Kashmir',
            gstCode: '01'
        }, {
            stateName: 'Himachal Pradesh',
            gstCode: '02'
        }, {
            stateName: 'Punjab',
            gstCode: '03'
        }, {
            stateName: 'Chandigarh',
            gstCode: '04'
        }, {
            stateName: 'Uttarakhand',
            gstCode: '05'
        }, {
            stateName: 'Haryana',
            gstCode: '06'
        }, {
            stateName: 'Delhi',
            gstCode: '07'
        }, {
            stateName: 'Rajasthan',
            gstCode: '08'
        }, {
            stateName: 'Uttar Pradesh',
            gstCode: '09'
        }, {
            stateName: 'Bihar',
            gstCode: '10'
        }, {
            stateName: 'Sikkim',
            gstCode: '11'
        }, {
            stateName: 'Arunachal Pradesh',
            gstCode: '12'
        }, {
            stateName: 'Nagaland',
            gstCode: '13'
        }, {
            stateName: 'Manipur',
            gstCode: '14'
        }, {
            stateName: 'Mizoram',
            gstCode: '15'
        }, {
            stateName: 'Tripura',
            gstCode: '16'
        }, {
            stateName: 'Meghalaya',
            gstCode: '17'
        }, {
            stateName: 'Assam',
            gstCode: '18'
        }, {
            stateName: 'West Bengal',
            gstCode: '19'
        }, {
            stateName: 'Jharkhand',
            gstCode: '20'
        }, {
            stateName: 'Orissa',
            gstCode: '21'
        }, {
            stateName: 'Chhatishgarh',
            gstCode: '22'
        }, {
            stateName: 'Madhya Pradesh',
            gstCode: '23'
        }, {
            stateName: 'Gujarat',
            gstCode: '24'
        }, {
            stateName: 'Daman-Diu',
            gstCode: '25'
        }, {
            stateName: 'Dadranagar Haveli',
            gstCode: '26'
        }, {
            stateName: 'Maharashtra',
            gstCode: '27'
        }, {
            stateName: 'Andhra Pradesh',
            gstCode: '37'
        }, {
            stateName: 'Karnataka',
            gstCode: '29'
        }, {
            stateName: 'Goa',
            gstCode: '30'
        }, {
            stateName: 'Lakhswadeep',
            gstCode: '31'
        }, {
            stateName: 'Kerala',
            gstCode: '32'
        }, {
            stateName: 'Tamil Nadu',
            gstCode: '33'
        }, {
            stateName: 'Pondicherry',
            gstCode: '34'
        }, {
            stateName: 'Andaman and Nicobar Islands',
            gstCode: '35'
        }, {
            stateName: 'Telangana',
            gstCode: '36'
        }]

    selectMonth() {
        // this.monthval = this.months.indexOf(this.month) + 1;
        this.getListData();
    }

//getCurrentPreviousQuarter() - Quareter 
   getCurrentPreviousQuarter(value:any) {
    var today = new Date(),
        quarter = Math.floor((today.getMonth() / 3)),
        startDate,
        endDate;

    switch (value) {
        case "previous":
            startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
            endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
            break;
        default:
            startDate = new Date(today.getFullYear(), quarter * 3, 1);
            endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
            break;
    }

    return {
        StartDate: startDate,
        EndDate: endDate
    };
}

//quarter_of_the_year() - Quorter of the month
quarter_of_the_year(date:any) {
    var month = date.getMonth() + 1;
    return (Math.ceil(month / 3));
}


    getListData() {

        this.supDetailArr = [];
        this.interSupArr = [];
        this.itcArr = [];
        this.inEligibleArr = [];
        this.itcRevArr = [];
        this.inwardSuppliesArr = [];
        this.itcNetArr = [];
        this.intr_detailsArr = []
       

        let selectedMnthID = this.selectedMonthID;
        let selectedMonth: any = this.monthList.filter(o => o.id == selectedMnthID);
        this.monthval = selectedMonth[0].number;
        this.year = selectedMonth[0].year;

        //new
        let currDate = new Date();
        let gstrMonth:any = currDate.getMonth();

        //let selectedMonthQtr = currDate.customFormat('#MM#');
        //let selectedYear = currDate.customFormat('#YYYY#');
        let prdType = 'MM';
        let prdQty = 1;

       if (this.period == 1) {
            gstrMonth = this.getCurrentPreviousQuarter("current").EndDate.customFormat('#MM##YYYY#');
            let currentStartDT = this.getCurrentPreviousQuarter("current").StartDate;
            //this.monthval = new Date(currentStartDT).getMonth();
            this.year = new Date(currentStartDT).getFullYear();
            prdType = 'QQ' + this.quarter_of_the_year(new Date(currentStartDT));
            prdQty = 3
        }
        else if (this.period == 2) {
            gstrMonth = this.getCurrentPreviousQuarter("previous").EndDate.customFormat('#MM##YYYY#');
            let currentStartDT = this.getCurrentPreviousQuarter("previous").StartDate;
            //this.monthval = new Date(currentStartDT).getMonth();
            this.year = new Date(currentStartDT).getFullYear();
            prdType = 'QQ' + this.quarter_of_the_year(new Date(currentStartDT));
            prdQty = 3
        } 
        //end

        var tempData = [{
            'month': this.monthval + '',
            'year': this.year + '',
            'GST': (this.isEGST ? this.selectedGST : this.ownGST),
            'prdType': prdType,
            'prdQty': prdQty 
        }]

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'get',
            moduleID: 7,
            data: JSON.stringify(tempData)
        }];
        this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }

  //new
  changeFilter(obj:any) {
    if (obj == 1) {
        this.period = 1;
        this.getListData();
    } else if (obj == 2) {
        this.period = 2;
        this.getListData();
    } else {
        this.period = 3;
        this.getListData();
    }
}

    //successResp - success  get handler
    successResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData) {
                    var dataRes = reponseData;
                    if (dataRes) {
                        this.DataList = dataRes;
                        this.callAPI();
                    }
                    else {
                    }
                }
            }
        }
    }

    callAPI() {
        this.createGSTRArray();
        this.createInterSupArray();
        this.createITCEligibleArray();
        this.createITCInEligibleArray();
        this.createInwardSuppliesArray();
        this.calculateItcNet();
    }

    //failureResp - failure handler
    failureResp(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

    //createGStArray
    createGSTRArray() {
        this.DataList.Table1.forEach((item: any, key: any) => {
            if (item.SupType == "osup_zero") {
                this.supDetailObj.type = '(b) Outward taxable supplies (zero-rated)';
                this.supDetailObj.count = 1;

            }
            else if (item.SupType == "osup_nil_exmp") {
                this.supDetailObj.type = '(c) Other outward supplies (nil-rated, exempted)';
                this.supDetailObj.count = 2;

            }
            else if (item.SupType == "osup_nongst") {
                this.supDetailObj.type = '(e) Non-GST outward supplies';
                this.supDetailObj.count = 4;
            }
            else if (item.SupType == "osup_det") {
                this.supDetailObj.type = '(a) Outward taxable supplies (other than zero-rated, nil-rated and exempted)';
                this.supDetailObj.count = 0;
            }
            else {
                this.supDetailObj.type = '(d) Inward supplies (liable to reverse charge)';
                this.supDetailObj.count = 3;
            }
            this.supDetailObj.SupType = item.SupType;
            this.supDetailObj.samt = item.SAMT + '';
            this.supDetailObj.csamt = item.CSAMT + '';
            this.supDetailObj.txval = item.TaxableVal + '';
            this.supDetailObj.camt = item.CAMT + '';
            this.supDetailObj.iamt = item.IAMT + '';
            this.supDetailObj.total_tax = item.SAMT + item.CSAMT + item.CAMT + item.IAMT + '';
            this.supDetailArr.push(this.supDetailObj);
            this.resetObj()

        })
    }

    //create inter sup array
    createInterSupArray() {
        var count = 0;
        //get Unreg Arr
        let tempUnregArr = $.grep(this.DataList.Table2, function (item: any) {
            if (item.IType == "unreg_details") {
                return item;
            }
        })
        tempUnregArr.forEach((item: any, key: any) => {

            this.interSupObj.type = 'Supplies made to Unregistered Persons';
            this.interSupObj.state = '';
            this.interSupObj.IType = item.IType;
            this.interSupObj.txval = item.TaxableVal + '';
            this.interSupObj.iamt = item.IAMT + '';
            this.interSupObj.count = count;
            count = count + 1;
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
        })
        if (tempUnregArr.length == 0) {
            this.interSupObj.type = 'Supplies made to Unregistered Persons';
            this.interSupObj.state = '';
            this.interSupObj.IType = '';
            this.interSupObj.txval = 0 + '';
            this.interSupObj.iamt = 0 + '';
            this.interSupObj.count = count;
            count = count + 1;
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
        }

        //get Composition Detail Arr
        let tempCompdetailArr = $.grep(this.DataList.Table2, function (item: any) {
            if (item.IType == "comp_details") {
                return item;
            }
        })

        tempCompdetailArr.forEach((item: any, key: any) => {

            this.interSupObj.type = 'Supplies made to Compostion Taxable Persons';
            this.interSupObj.state = '';
            this.interSupObj.IType = item.IType;
            this.interSupObj.txval = item.TaxableVal + '';
            this.interSupObj.iamt = item.IAMT + '';
            this.interSupObj.count = count;
            count = count + 1;
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
        })

        if (tempCompdetailArr.length == 0) {
            this.interSupObj.type = 'Supplies made to Compostion Taxable Persons';
            this.interSupObj.state = '';
            this.interSupObj.IType = '';
            this.interSupObj.txval = 0 + '';
            this.interSupObj.iamt = 0 + '';
            this.interSupObj.count = count;
            count = count + 1;
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
        }

        //get UIN Detail Arr
        let tempUinDetailArr = $.grep(this.DataList.Table2, function (item: any) {
            if (item.IType == "uin_details") {
                return item;
            }
        })

        tempUinDetailArr.forEach((item: any, key: any) => {

            this.interSupObj.type = 'Supplies made to UIN holders';
            this.interSupObj.state = '';
            this.interSupObj.IType = item.IType;
            this.interSupObj.txval = item.TaxableVal + '';
            this.interSupObj.iamt = item.IAMT + '';
            this.interSupObj.count = count;
            count = count + 1;
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
            this.setState(item.STATE, key)
 
        })

        if (tempUinDetailArr.length == 0) {
            this.resetObj();
            this.interSupObj.type = 'Supplies made to UIN holders';
            this.interSupObj.state = '';
            this.interSupObj.IType = '';
            this.interSupObj.txval = 0 + '';
            this.interSupObj.iamt = 0 + '';
            this.interSupObj.count = count;
            count = count + 1;
            try {
                //this.$digest();
                this.ref.detectChanges();
            }
            catch (e) {

            }
            this.interSupArr.push(this.interSupObj);
            //console.log(this.interSupArr)
            this.resetObj();
        }
    }

    //createITCE
    createITCEligibleArray() {
        var tempItcAvl = $.grep(this.DataList.Table3, function (i: any) {
            if (i.IType == "itc_avl") {
                return i;
            }
        })

        tempItcAvl.forEach((item: any, key: any) => {
            if (item.TY == "IMPS") {
                this.itcObj.type = '(1) Import of Goods';
            }
            else if (item.TY == "IMPG") {
                this.itcObj.type = '(2) Import of Services';
            }
            else if (item.TY == "ISRC") {
                this.itcObj.type = '(3) Inward supplies liable to reverse charge (other than 1 & 2 above)';
            }
            else if (item.TY == "ISD") {
                this.itcObj.type = '(4) Inward supplies from ISD';
            }
            else {
                this.itcObj.type = '(5) All other ITC';
            }
            this.itcObj.ty = item.TY;
            this.itcObj.samt = item.SAMT + '';
            this.itcObj.csamt = item.CSAMT + '';
            this.itcObj.camt = item.CAMT + '';
            this.itcObj.iamt = item.IAMT + '';
            this.itcArr.push(this.itcObj);
            this.resetObj();
        })

        var tempItcNetArr = $.grep(this.DataList.Table3, function (i: any) {
            if (i.IType == "itc_net") {
                return i;
            }
        })

        this.itcNetArr = [{
            samt: tempItcNetArr[0].SAMT + "",
            csamt: tempItcNetArr[0].CSAMT + "",
            camt: tempItcNetArr[0].CAMT + "",
            iamt: tempItcNetArr[0].IAMT + ""
        }]
        
    }

    createITCInEligibleArray() {
        var tempItcInElg = $.grep(this.DataList.Table3, function (i: any) {
            if (i.IType == "itc_inelg") {
                return i;
            }
        })

        var tempItcRevArr = $.grep(this.DataList.Table3, function (i: any) {
            if (i.IType == "itc_rev") {
                return i;
            }
        })

        tempItcInElg.forEach((item: any, key: any) => {

            if (item.TY == "RUL") {
                this.itcObj.type = '(1) As per section 17(5)';
            }
            else {
                this.itcObj.type = '(2) Others';
            }
            this.itcObj.ty = item.TY;
            this.itcObj.samt = item.SAMT + "";
            this.itcObj.csamt = item.CSAMT + "";
            this.itcObj.camt = item.CAMT + "";
            this.itcObj.iamt = item.IAMT + "";
            this.inEligibleArr.push(this.itcObj);
            this.resetObj();
            //console.log(this.inEligibleArr);
        })

        tempItcRevArr.forEach((item: any, key: any) => {

            if (item.TY == "RUL") {
                this.itcObj.type = '(1) As per rules 42 & 43 of CGST Rules';
            }
            else {
                this.itcObj.type = '(2) Others';
            }
            this.itcObj.ty = item.TY;
            this.itcObj.samt = item.SAMT + "";
            this.itcObj.csamt = item.CSAMT + "";
            this.itcObj.camt = item.CAMT + "";
            this.itcObj.iamt = item.IAMT + "";
            this.itcRevArr.push(this.itcObj);
            this.resetObj();
            //console.log(this.itcRevArr);
        })
    }

    createInwardSuppliesArray() {
        this.DataList.Table4.forEach((item: any, key: any) => {
            if (key == 0) {
                this.inwardSuppliesObj.name = 'Composition Scheme, Exempted, Nil-rated';
                this.inwardSuppliesObj.ty = "GST";
            }
            else {
                this.inwardSuppliesObj.name = 'Non-GST supply';
                this.inwardSuppliesObj.ty = "NONGST";
            }
            this.inwardSuppliesObj.intra = item.Intra + "";
            this.inwardSuppliesObj.inter = item.Inter + "";

            this.inwardSuppliesArr.push(this.inwardSuppliesObj);
            //console.log(this.inwardSuppliesArr);
            this.resetObj();
        })

        this.intr_detailsArr = [{
            samt: this.DataList.Table5[0].SAMT + '',
            csamt: this.DataList.Table5[0].CSAMT + '',
            camt: this.DataList.Table5[0].CAMT + '',
            iamt: this.DataList.Table5[0].IAMT + ''
        }]
        //this.createJSON();
    }

    //download JSON
    download(blob: any, filename: any) {
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(blob, filename);
        else { // Others
            var a = document.createElement("a"),
                url = URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }

        
    }

    exportJson(): void {
        this.createJSON();
        const c = JSON.stringify(this.GSTR3B);
        const file = new Blob([c], { type: 'text/json' });

        let tmpSelectedMnth = this.monthList.filter((x :any) => x.id == this.selectedMonthID);
        let fileName: string = "GSTR3B_Summary_" + this.agencyData[0].AgencyName;
        if(tmpSelectedMnth.length > 0){
            fileName = "GSTR3B_" + tmpSelectedMnth[0].year + "_" + tmpSelectedMnth[0].number;
        }
        this.download(file, fileName + ".json");
    }

    resetObj() {
        this.supDetailObj = {
            type: '',
            samt: 0 + '',
            csamt: 0 + '',
            txval: 0 + '',
            camt: 0 + '',
            iamt: 0 + '',
            count: 0,
            SupType: '',
            total_tax: 0 + ''
        }
        this.interSupObj = {
            type: '',
            state: '',
            pos: '',
            txval: 0 + '',
            iamt: 0 + '',
            count: 0,
            IType: ''
        }
        this.itcObj = {
            type: '',
            samt: 0 + '',
            csamt: 0 + '',
            camt: 0 + '',
            iamt: 0 + ''
        }
        this.inwardSuppliesObj = {
            ty: '',
            name: '',
            intra: 0 + '',
            inter: 0 + ''
        }

    }

    // this.$watch('supDetailArr', function (newVal, oldVal) {
    //     angular.forEach(this.supDetailArr, function (item, k) {
    //         item.total_tax = Number(item.samt) + Number(item.csamt) + Number(item.camt) + Number(item.iamt) + '';
    //     });
    //     var temp = angular.toJson(this.supDetailArr)
    //     $('#hdnSupplierData').val(temp);

    //     //console.log(temp);
    // }, true);

    changesupDetailArr(event: any) {
        this.supDetailArr.forEach((item: any, k: any) => {

            item.total_tax = Number(item.samt) + Number(item.csamt) + Number(item.camt) + Number(item.iamt) + '';
        });
        var temp = JSON.stringify(this.supDetailArr)
    }

    changeinterSupArr(event: any) {
        var tempInterSupArr = $.grep(this.interSupArr, function (i: any) {
            if (i.IType != '') {
                return i;
            }
        })
        var temp = JSON.stringify(tempInterSupArr)
    }

    changeitcArr(event: any) {
        var temp = JSON.stringify(this.itcArr)
        //console.log(this.itcArr);
        this.calculateItcNet();
    }

    changeitcRevArr(event: any) {
        var temp = JSON.stringify(this.itcRevArr)
        //console.log(this.itcArr);
        this.calculateItcNet();
    }

    changeinEligibleArr(event: any) {
        var temp = JSON.stringify(this.inEligibleArr)
        //console.log(this.itcArr);
        this.calculateItcNet();
    }

    changeitcNetArr(event: any) {
        var temp = JSON.stringify(this.itcNetArr)
        //console.log(this.itcArr);
        this.calculateItcNet();
    }

    changeinwardSuppliesArr(event: any) {
        var temp = JSON.stringify(this.inwardSuppliesArr)
        //console.log(this.itcArr);
        this.calculateItcNet();
    }


    setState =  (name: any, index: any) => {
        if (name != '') {
            if (index != undefined) {
                this.stateList.forEach((i: any, k: any) => {
                    if (String(i.stateName).toUpperCase() == String(this.interSupArr[index].state).toUpperCase()) {
                        this.interSupArr[index].pos = i.gstCode;
                        this.setItype(index);
                    }
                })
            }
        }
        if (this.interSupArr[index].stateName == '') {
            this.interSupArr[index].pos = 0;
        }
        else {
                this.stateList.forEach((i: any, k: any) => {
                if (i.gstCode == this.interSupArr[index].pos) {
                    this.interSupArr[index].state = i.stateName;
                }
            })
        }

        //console.log(this.interSupArr);
    }

     setItype(index: any) {
    if (this.interSupArr[index].type == 'Supplies made to Unregistered Persons') {
        this.interSupArr[index].IType = 'unreg_details';
    }
    else if (this.interSupArr[index].type == 'Supplies made to Compostion Taxable Persons') {
        this.interSupArr[index].IType = 'comp_details';
    }
    else {
        this.interSupArr[index].IType = 'uin_details';
    }
}
            

calculateItcNet() {
    if (this.itcNetArr.length > 0) {
        this.itcNetArr[0].iamt = 0 + '';
        this.itcNetArr[0].samt = 0 + '';
        this.itcNetArr[0].camt = 0 + '';
        this.itcNetArr[0].csamt = 0 + '';


        this.itcArr.forEach((item: any, k: any) => {

            this.itcNetArr[0].iamt = Number(this.itcNetArr[0].iamt) + Number(item.iamt) + '';
            this.itcNetArr[0].samt = Number(this.itcNetArr[0].samt) + Number(item.samt) + '';
            this.itcNetArr[0].camt = Number(this.itcNetArr[0].camt) + Number(item.camt) + '';
            this.itcNetArr[0].csamt = Number(this.itcNetArr[0].csamt) + Number(item.csamt) + '';

        })
        this.itcRevArr.forEach((item: any, k: any) => {

            this.itcNetArr[0].iamt = Number(this.itcNetArr[0].iamt) - Number(item.iamt) + '';
            this.itcNetArr[0].samt = Number(this.itcNetArr[0].samt) - Number(item.samt) + '';
            this.itcNetArr[0].camt = Number(this.itcNetArr[0].camt) - Number(item.camt) + '';
            this.itcNetArr[0].csamt = Number(this.itcNetArr[0].csamt) - Number(item.csamt) + '';
        })

        if (Number(this.itcNetArr[0].iamt) < 0) {
            this.itcNetArr[0].iamt = 0 + '';
        }
        if (Number(this.itcNetArr[0].samt) < 0) {
            this.itcNetArr[0].samt = 0 + '';
        }
        if (Number(this.itcNetArr[0].camt) < 0) {
            this.itcNetArr[0].camt = 0 + '';
        }
        if (Number(this.itcNetArr[0].csamt) < 0) {
            this.itcNetArr[0].csamt = 0 + '';
        }
    }

    
}


createJSON()
{
    
    this.GSTR3B.gstin = this.agencyData[0].GSTIN;
    this.GSTR3B.ret_period = this.monthval + '' + this.year;

    //Sup Table
    this.supDetailArr.forEach((s: any, key:any) => {
        if(s.SupType == 'osup_det') {
            this.GSTR3B.sup_details["osup_det"] = {};
        }
        else if(s.SupType == 'osup_zero') {
            this.GSTR3B.sup_details["osup_zero"] = {};
        }
        else if(s.SupType == 'osup_nil_exmp') {
            this.GSTR3B.sup_details["osup_nil_exmp"] = {};
        }
        else if(s.SupType == 'isup_rev') {
            this.GSTR3B.sup_details["isup_rev"] = {};
        }
        if(s.SupType == 'osup_nongst') {
            this.GSTR3B.sup_details["osup_nongst"] = {};
        }
    });

    this.supDetailArr.forEach((s: any) => {
        if(this.GSTR3B.sup_details['osup_det'] || this.GSTR3B.sup_details['osup_zero'] || this.GSTR3B.sup_details['osup_nil_exmp'] || this.GSTR3B.sup_details['isup_rev'] || this.GSTR3B.sup_details['osup_nongst']) {
            if(s.SupType =='osup_det' || s.SupType =='osup_zero' || s.SupType =='osup_nil_exmp' || s.SupType =='isup_rev' || s.SupType =='osup_nongst'){
                this.GSTR3B.sup_details[s.SupType]['txval'] = parseFloat(s.txval);
                this.GSTR3B.sup_details[s.SupType]['iamt'] = parseFloat(s.iamt);
                this.GSTR3B.sup_details[s.SupType]['camt'] = parseFloat(s.camt);
                this.GSTR3B.sup_details[s.SupType]['samt'] = parseFloat(s.samt);
                this.GSTR3B.sup_details[s.SupType]['csamt'] = parseFloat(s.csamt);
                // this.GSTR3B.sup_details[s.SupType]['total_tax'] = s.total_tax;
            }
        }
    });

    //inter_sup
    this.GSTR3B.inter_sup['unreg_details'] = [];
    this.GSTR3B.inter_sup['comp_details'] = [];
    this.GSTR3B.inter_sup['uin_details'] = [];
    this.interSupArr.forEach((i: any) => {
        if(i.IType == 'unreg_details') {
            this.GSTR3B.inter_sup.unreg_details.push({
            'pos': i.pos,
            'txval': parseFloat(i.txval),
            'iamt': parseFloat(i.iamt)
           });
        }

        if(i.IType == 'comp_details') {
            this.GSTR3B.inter_sup.comp_details.push({
                'pos': i.pos,
                'txval': parseFloat(i.txval),
                'iamt': parseFloat(i.iamt)
            });
        }

        if(i.IType == 'uin_details') {
            this.GSTR3B.inter_sup.uin_details.push({
                'pos': i.pos,
                'txval': parseFloat(i.txval),
                'iamt': parseFloat(i.iamt)
            });
        }
    });

    //itc_elg
    if(this.itcArr.length > 0) {
        this.GSTR3B.itc_elg['itc_avl'] = [];
        this.itcArr.forEach((i: any) => {
            this.GSTR3B.itc_elg.itc_avl.push({
                'ty': i.ty,
                'iamt': parseFloat(i.iamt),
                'camt': parseFloat(i.camt),
                'samt': parseFloat(i.samt),
                'csamt': parseFloat(i.csamt)
            })
        });
    }

    if(this.itcRevArr.length > 0) {
        this.GSTR3B.itc_elg['itc_rev'] = [];
        this.itcRevArr.forEach((i: any) => {
            this.GSTR3B.itc_elg.itc_rev.push({
                'ty': i.ty,
                'iamt': parseFloat(i.iamt),
                'camt': parseFloat(i.camt),
                'samt': parseFloat(i.samt),
                'csamt': parseFloat(i.csamt)
            })
        });
    }

    if(this.itcNetArr.length > 0) {
        // this.GSTR3B.itc_elg['itc_net'] = [];
        this.GSTR3B.itc_elg['itc_net'] = {};
        let itcSamt: number = 0;
        let itccsamt: number = 0;
        let itcamt: number = 0;
        let itciamt: number = 0;
        this.itcNetArr.forEach((i: any) => {
            itcSamt = Number((Number(itcSamt) + Number(i.samt)).toFixed(2));
            itccsamt = Number((Number(itccsamt) + Number(i.csamt)).toFixed(2));
            itcamt = Number((Number(itcamt) + Number(i.camt)).toFixed(2));
            itciamt = Number((Number(itciamt) + Number(i.iamt)).toFixed(2));
            // this.GSTR3B.itc_elg.itc_net.push({
            //     'samt': i.samt,
            //     'csamt': i.csamt,
            //     'camt': i.camt,
            //     'iamt': i.iamt
            // });
        });

        this.GSTR3B.itc_elg.itc_net = {
            'samt': itcSamt,
            'csamt': itccsamt,
            'camt': itcamt,
            'iamt': itciamt
        };
    }

    if(this.inEligibleArr.length > 0) {
        this.GSTR3B.itc_elg['itc_inelg'] = [];
        this.inEligibleArr.forEach((i: any) => {
            this.GSTR3B.itc_elg.itc_inelg.push({
                'ty': i.ty,
                'iamt': parseFloat(i.iamt),
                'camt': parseFloat(i.camt),
                'samt': parseFloat(i.samt),
                'csamt': parseFloat(i.csamt)
            })
        });
    }
    
    //inward_sup
    this.GSTR3B.inward_sup['isup_details'] = [];
    if(this.inwardSuppliesArr.length > 0) {
        this.inwardSuppliesArr.forEach((is: any) => {
            this.GSTR3B.inward_sup.isup_details.push({
                'ty': is.ty,
                'inter': parseFloat(is.inter),
                'intra': parseFloat(is.intra)
            });
        });
    }
    
    this.GSTR3B.intr_ltfee['intr_details'] = {
        'iamt': 0,
        'camt': 0,
        'samt': 0,
        'csamt': 0
    };

    this.GSTR3B.intr_ltfee['ltfee_details'] = {};

    // this.GSTR3B.hash = 'hash';
    // this.GSTR3B.version = 'GST1.00';

    // console.log('GSTR3B', this.GSTR3B);

}


}
